module.exports = __webpack_public_path__ + "media/images/athletes/3432-25cab45f38d2293459eecfb947f57cf2.png";